import type { MutationResult, QueryResult } from '@/domain/shared/types';

/** Must match `StreamQualityEnum` in the internal API; persisted as DB `HD` / `standard`. */
export type StreamQuality = 'HD' | 'STANDARD';

export const MIN_DAILY_STREAMING_LIMIT_SECONDS = 10 * 60;
export const MIN_MAX_SESSION_TIME_SECONDS = 5 * 60;

export interface VideoStreamSettingsValues {
    dailyLimitSeconds: number;
    maxContinuousDurationSeconds: number;
    defaultQuality: StreamQuality;
}

export interface BioscopeVideoStreamSettings {
    bioscope: {
        id: number;
        version: string;
        lastAlive: string | null;
    };
    location: {
        id: number;
        name: string;
        timezone: string;
    };
    cage: {
        id: number;
        name: string;
    };
    settings: VideoStreamSettingsValues;
    currentDailyUsageSeconds: number;
}

export interface LocationVideoStreamSettingsGroup {
    locationId: number;
    locationName: string;
    timezone: string;
    bioscopes: BioscopeVideoStreamSettings[];
}

export interface ClientVideoStreamSettings {
    rows: BioscopeVideoStreamSettings[];
    locations: LocationVideoStreamSettingsGroup[];
}

export interface UpdateBioscopeVideoStreamSettingsVariables {
    clientId: number;
    bioscopeId: number;
    requestBody: VideoStreamSettingsValues;
}

export interface UpdateLocationVideoStreamSettingsVariables {
    clientId: number;
    locationId: number;
    requestBody: VideoStreamSettingsValues;
}

export interface UseGetClientVideoStreamSettingsResult
    extends QueryResult<ClientVideoStreamSettings> {
    isError: boolean;
}

export interface UseUpdateBioscopeVideoStreamSettingsResult
    extends MutationResult<VideoStreamSettingsValues, UpdateBioscopeVideoStreamSettingsVariables> {}

export interface UseUpdateLocationVideoStreamSettingsResult
    extends MutationResult<
        VideoStreamSettingsValues[],
        UpdateLocationVideoStreamSettingsVariables
    > {}
